/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(11);


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Give - Stripe Gateway Payment Request JS
 */

var stripe = Stripe(give_stripe_vars.publishable_key);
if (give_stripe_vars.stripe_account_id) {
	stripe = Stripe(give_stripe_vars.publishable_key, { stripeAccount: give_stripe_vars.stripe_account_id });
}

document.addEventListener('DOMContentLoaded', function () {

	// Get all the donation forms on a single page.
	var formWraps = document.querySelectorAll('.give-form-wrap');
	var prButton = [];
	var paymentRequest = [];
	var isPRButtonExists = [];
	var defaultGateway = '';
	var preferredLocale = give_stripe_vars.preferred_locale;

	// Loop through each donation form.
	Array.prototype.forEach.call(formWraps, function (formWrap) {

		var form_element = formWrap.querySelector('.give-form');

		var elements = stripe.elements({
			locale: preferredLocale
		});

		if (null !== form_element.querySelector('.give-gateway-option-selected .give-gateway').value) {
			defaultGateway = form_element.querySelector('.give-gateway-option-selected .give-gateway').value;
		}

		var idPrefix = form_element.getAttribute('data-id');

		// Set default value for payment request button exists flag.
		isPRButtonExists[idPrefix] = false;

		// Set default gateway value on changing gateway.
		Array.prototype.forEach.call(form_element.querySelectorAll('.give-gateway'), function (gateway_element) {
			gateway_element.addEventListener('change', function (e) {
				if (gateway_element.checked) {
					defaultGateway = gateway_element.value;
				}
			});
		});

		// Prepare tabs and payment request button on gateway load.
		jQuery(document).on('give_gateway_loaded', function (event, xhr, settings) {
			if (defaultGateway === 'stripe') {
				prepareStripeCCTabs();
				preparePaymentRequestButton(idPrefix, elements);
			}
		});

		// Trigger build tabs custom event when required.
		function prepareStripeCCTabs() {
			var tabElements = form_element.querySelectorAll('ul.give-stripe-payment-tabs li a');

			// Bailout, if tabElements doesn't exists.
			if (null === tabElements) {
				return;
			}

			// Payment Tabs to support Google/Apple Pay.
			Array.prototype.forEach.call(tabElements, function (tabElement) {
				var purchaseSubmit = form_element.querySelector('.give-submit-button-wrap');
				var paymentRequestSubmit = form_element.querySelector('.give-stripe-payment-request-content');
				var errorElement = form_element.querySelector('#give-stripe-payment-errors-' + idPrefix);

				purchaseSubmit.style.display = 'block';
				paymentRequestSubmit.style.display = 'none';

				tabElement.addEventListener('click', function (e) {
					var currentParentTag = this.parentElement;
					var currentElementID = form_element.querySelector(this.getAttribute('href'));

					Array.prototype.forEach.call(tabElements, function (tab) {
						var currentTab = form_element.querySelector(tab.getAttribute('href'));

						// Reset tabs and its content.
						currentTab.style.display = 'none';
						tab.parentElement.className = '';
					});

					// Reset error on switching tabs.
					errorElement.innerHTML = '';

					// Hide standard donate button when Google or Apple Pay is displayed.
					if ('#give-stripe-payment-request-content' === this.getAttribute('href')) {
						purchaseSubmit.style.display = 'none';
						paymentRequestSubmit.style.display = 'block';

						// Create a new hidden field is_payment_request, if if it doesn't exist.
						if (!form_element.querySelector('input[name="is_payment_request"]')) {
							var isPaymentRequestFlag = document.createElement('input');
							isPaymentRequestFlag.setAttribute('type', 'hidden');
							isPaymentRequestFlag.setAttribute('name', 'is_payment_request');
							isPaymentRequestFlag.setAttribute('value', true);
							form_element.appendChild(isPaymentRequestFlag);
						}
					} else if ('#give-stripe-credit-card-content' === this.getAttribute('href')) {
						paymentRequestSubmit.style.display = 'none';
						purchaseSubmit.style.display = 'block';

						// Remove the hidden field "is_payment_request" used as flag.
						form_element.querySelector('input[name="is_payment_request"]').remove();
					}

					// Display active tab content.
					currentElementID.style.display = 'block';

					// Add active class to clicked tab.
					currentParentTag.className = !currentParentTag.classList.contains('active') ? currentParentTag.classList + 'active' : currentParentTag.classList;

					// Prevent user from redirection.
					e.preventDefault();
				});
			});
		}

		/**
   * Prepare Payment Request Button.
   *
   * @param {string} idPrefix ID Prefix.
   * @param {object} elements Stripe Elements Object.
   *
   * @since 1.6
   */
		function preparePaymentRequestButton(idPrefix, elements) {
			var _this = this;

			var formName = form_element.querySelector('input[name="give-form-title"]');
			var donationAmount = Give.fn.unFormatCurrency(form_element.querySelector('.give-final-total-amount').dataset.total, form_element.dataset.decimal_separator);

			paymentRequest[idPrefix] = stripe.paymentRequest({
				country: give_stripe_vars.base_country,
				currency: form_element.getAttribute('data-currency_code').toLowerCase(),
				total: {
					label: formName.value,
					amount: Math.round(donationAmount * 100)
				},
				requestShipping: false,
				requestPayerName: true
			});

			if (false === isPRButtonExists[idPrefix]) {

				prButton[idPrefix] = elements.create('paymentRequestButton', {
					paymentRequest: paymentRequest[idPrefix],
					style: {
						paymentRequestButton: {
							type: 'donate',
							theme: give_stripe_vars.payment_request_button_style,
							height: '64px'
						}
					}
				});

				isPRButtonExists[idPrefix] = true;
			}

			// Check the availability of the Payment Request API first.
			paymentRequest[idPrefix].canMakePayment().then(function (result) {
				var paymentRequestButton = document.getElementById('give-stripe-payment-request-button-' + idPrefix);

				if (paymentRequestButton) {
					if (result) {
						prButton[idPrefix].mount('#give-stripe-payment-request-button-' + idPrefix);
						isPRButtonExists[idPrefix] = true;
					}
					paymentRequestButton.style.display = 'block';
				}
			});

			paymentRequest[idPrefix].on('source', function () {
				var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ev) {
					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									form_element.querySelector('input[name="give_stripe_source"]').value = ev.source.id;
									form_element.querySelector('input[name="card_address"]').value = ev.source.owner.address.line1;
									form_element.querySelector('input[name="card_address_2"]').value = ev.source.owner.address.line2;
									form_element.querySelector('input[name="card_city"]').value = ev.source.owner.address.city;
									form_element.querySelector('input[name="card_zip"]').value = ev.source.owner.address.postal_code;

									autoSelectCountry(ev.source.owner.address.country);
									autoSelectState(ev.source.owner.address.country, ev.source.owner.address.state);

									setTimeout(function () {
										form_element.submit();
										ev.complete('success');
									}, 2000);

								case 8:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, _this);
				}));

				return function (_x) {
					return _ref.apply(this, arguments);
				};
			}());

			prButton[idPrefix].on('click', function (evt) {

				var verifyPayment = new XMLHttpRequest();
				var formData = new FormData(form_element);
				var errorElement = form_element.querySelector('#give-stripe-payment-errors-' + idPrefix);
				donationAmount = Give.fn.unFormatCurrency(form_element.querySelector('.give-final-total-amount').dataset.total, form_element.dataset.decimal_separator);

				formData.append('action', 'give_process_donation');
				formData.append('give_ajax', true);

				paymentRequest[idPrefix].update({
					currency: form_element.getAttribute('data-currency_code').toLowerCase(),
					total: {
						label: formName.value,
						amount: Math.round(donationAmount * 100)
					}
				});

				// Do something on Ajax on state change.
				verifyPayment.onreadystatechange = function () {

					if (4 === this.readyState && 200 === this.status && 'success' !== this.responseText) {
						evt.preventDefault();
						errorElement.innerHTML = this.response;
					} else {
						errorElement.innerHTML = '';
					}
				};
				verifyPayment.open('POST', give_global_vars.ajaxurl, false);
				verifyPayment.send(formData);
			});
		}

		// Load custom events when default gateway is stripe on load.
		if ('stripe' === defaultGateway) {
			prepareStripeCCTabs();
			preparePaymentRequestButton(idPrefix, elements);
		}

		/**
   * This function is used to dynamically select the country.
   *
   * @param {string} country Name of the country.
   *
   * @since 2.2.0
   */
		function autoSelectCountry(country) {

			var element = form_element.querySelector('select[name="billing_country"]');
			var option = element.getElementsByTagName('option');

			for (var i = 0; i < option.length; i++) {
				option[i].selected = false;
				option[i].removeAttribute('selected');
				if (option[i].value === country) {
					option[i].selected = true;
					option[i].setAttribute('selected', 'selected');
				}
			}
			// return null;
		}

		/**
   * This function is used to dynamically select the states based on country.
   *
   * @param {string} country Name of the Country.
   * @param {string} state   Name of the State.
   *
   * @since 2.2.0
  	 */
		function autoSelectState(country, state) {

			var updateStates = new XMLHttpRequest();
			var formData = new FormData();

			formData.append('action', 'give_get_states');
			formData.append('country', country);
			formData.append('field_name', 'card_state');

			// Do something on Ajax on state change.
			updateStates.onreadystatechange = function () {

				if (4 === this.readyState && 200 === this.status && 'success' !== this.responseText) {
					var response = JSON.parse(this.response);
					var selectElementWrap = form_element.querySelector('#give-card-state-wrap');
					selectElementWrap.querySelector('select[name="card_state"]').remove();

					selectElementWrap.innerHTML = selectElementWrap.innerHTML + response.data;

					var element = form_element.querySelector('select[name="card_state"]');
					var option = element.getElementsByTagName('option');

					for (var i = 0; i < option.length; i++) {
						option[i].selected = false;
						option[i].removeAttribute('selected');

						if (option[i].value === state || option[i].textContent === state) {
							option[i].selected = true;
							option[i].setAttribute('selected', 'selected');
						}
					}
				}
			};
			updateStates.open('POST', give_global_vars.ajaxurl, false);
			updateStates.send(formData);
		}
	});
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/give-stripe-payment-request.js